import { Auth, API } from 'aws-amplify';

export default {
  namespaced: true,
  state: {
    user: null,
    isSignIn: false,
    userAttribute: {},
    deviceType: window.location.href.indexOf('cloudfront') !== -1 ? 'imacloud' : '',
    accessToken: null,
    chatUuid: null,
  },
  getters: {
  },
  mutations: {
    setUserAttribute(state, attribute) {
      state.userAttribute = attribute;
    },
    setUserAccessToken(state, token) {
      state.accessToken = token;
    },
    setUserUuid(state, uuid) {
      state.chatUuid = uuid;
    },
  },
  actions: {
    signIn({ state }, { email, password }) {
      return new Promise((resolve, reject) => {
        Auth.signIn(email, password).then((user) => {
          state.user = user;
          state.isSignIn = true;
          resolve(user);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    signOut({ state }) {
      return new Promise((resolve, reject) => {
        Auth.signOut().then((result) => {
          state.user = null;
          state.isSignIn = false;
          state.userAttribute = {};
          resolve(result);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    resendVerifyCode(context, { email }) {
      return new Promise((resolve, reject) => {
        API.post('API', '/awsCognito', { body: { operation: 'resendTempPassword', userPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID, email } }).then((response) => {
          resolve(response);
        }).catch(() => {
          API.post('API', '/awsCognito', { body: { operation: 'resendTempPassword', userPoolId: process.env.VUE_APP_COGNITO_OLD_USER_POOL_ID, email } }).then((response) => {
            resolve(response);
          }).catch((err) => {
            reject(err);
          });
        });
      });
    },
    forgotPassword(context, { email }) {
      return new Promise((resolve, reject) => {
        Auth.forgotPassword(email).then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    forgotPasswordSubmit(context, { email, code, newPassword }) {
      return new Promise((resolve, reject) => {
        Auth.forgotPasswordSubmit(email, code, newPassword).then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    changePassword({ state }, { password, newPassword }) {
      return new Promise((resolve, reject) => {
        Auth.changePassword(state.user, password, newPassword).then((result) => {
          resolve(result);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    changeNewPassword({ state }, { newPassword }) {
      return new Promise((resolve, reject) => {
        Auth.completeNewPassword(state.user, newPassword).then((result) => {
          resolve(result);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    currentUser({ state }) {
      return new Promise((resolve, reject) => {
        Auth.currentAuthenticatedUser({ bypassCache: false }).then((user) => {
          state.user = user;
          state.isSignIn = true;
          resolve(user);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    oauthSignInUrl({ state }, { redirectUrl }) {
      return new Promise((resolve, reject) => {
        API.post('API', '/oauth', { body: { operation: 'loginUrl', redirectUrl, type: state.deviceType } }).then((url) => {
          resolve(url.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    oauthSignOutUrl({ state }, { redirectUrl }) {
      return new Promise((resolve, reject) => {
        API.post('API', '/oauth', { body: { operation: 'logoutUrl', redirectUrl, type: state.deviceType } }).then((url) => {
          resolve(url.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    oauthToken({ state }, {
      refreshToken, code, localUrl, remoteUrl,
    }) {
      return new Promise((resolve, reject) => {
        const redirectUrl = remoteUrl != null ? `${localUrl}?redirect_uri=${remoteUrl}` : `${localUrl}`;
        API.post('API', '/oauth', {
          body: {
            operation: 'oauthToken', code, redirectUrl, refreshToken, type: state.deviceType,
          },
        }).then((result) => {
          resolve(result.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    oauthCurrentUser({ state }, { accessToken }) {
      return new Promise((resolve, reject) => {
        API.post('API', '/oauth', { body: { operation: 'userInfo', accessToken } }).then((response) => {
          state.isSignIn = true;
          state.user = { email: response.data.email, cognitoId: response.data.cognitoId };
          resolve({ attributes: state.user });
        }).catch((error) => {
          reject(error);
        });
      });
    },
    oauthChangePassword({ state }, { password, newPassword }) {
      return new Promise((resolve, reject) => {
        API.post('API', '/awsCognito', {
          body: {
            operation: 'changePassword', accessToken: state.accessToken, password, newPassword,
          },
        }).then((result) => {
          resolve(result);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    totpStatus({ state }) {
      return new Promise((resolve, reject) => {
        API.post('API', '/awsCognito', { body: { operation: 'totpStatus', accessToken: state.accessToken } }).then((result) => {
          resolve(result.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    totpEnable({ state }, { enable }) {
      return new Promise((resolve, reject) => {
        if (enable) {
          API.post('API', '/awsCognito', { body: { operation: 'totpEnable', accessToken: state.accessToken } }).then((result) => {
            resolve(result.data);
          }).catch((error) => {
            reject(error);
          });
        } else {
          API.post('API', '/awsCognito', { body: { operation: 'totpDisable', accessToken: state.accessToken } }).then((result) => {
            resolve(result.data);
          }).catch((error) => {
            reject(error);
          });
        }
      });
    },
    totpVerify({ state }, { code }) {
      return new Promise((resolve, reject) => {
        API.post('API', '/awsCognito', { body: { operation: 'totpVerify', accessToken: state.accessToken, code } }).then((result) => {
          console.log('verify', result);
          resolve(result);
        }).catch((error) => {
          reject(error);
        });
      });
    },
  },
};
